'use client';

import { useEffect, useState } from 'react';

export enum ImageLoadingStatus {
  Idle = 'idle',
  Loading = 'loading',
  Error = 'error',
  Success = 'success',
}

export function useImageLoader(src: string | undefined) {
  const [status, setStatus] = useState<ImageLoadingStatus>(src ? ImageLoadingStatus.Loading : ImageLoadingStatus.Idle);

  useEffect(() => {
    let img: HTMLImageElement | null = null;

    if (src) {
      setStatus(ImageLoadingStatus.Loading);

      img = new Image();

      img.onload = () => {
        setStatus(ImageLoadingStatus.Success);
      };

      img.onerror = () => {
        setStatus(ImageLoadingStatus.Error);
      };

      img.src = src;
    } else {
      setStatus(ImageLoadingStatus.Idle);
    }

    return () => {
      img?.remove();
    };
  }, [src]);

  return status;
}
